import { MasonryStatusBannerRenderer } from '@leagueplatform/masonry-renderers';

type MasonryStatusBannerProps = Parameters<
  typeof MasonryStatusBannerRenderer
>[0];

// Nodes that author their own leadingIcon keep it.
const INFO_LEADING_ICON = {
  type: 'url' as const,
  value: 'statusInformationCircle2Filled',
  iconAltText: '',
};

export const ScfhpStatusBannerRenderer = (props: MasonryStatusBannerProps) => {
  const { status, leadingIcon } = props;

  return (
    <MasonryStatusBannerRenderer
      {...props}
      leadingIcon={
        status === 'info' && !leadingIcon ? INFO_LEADING_ICON : leadingIcon
      }
    />
  );
};
